module.exports = __webpack_public_path__ + "img/今日头条_01.5f34c5ae.jpg";